import { AdSenseForShopping } from '../ad-sense-for-shopping';
import { useAdSenseObjectPage } from '../../hooks/adSense';
import * as React from 'react';
import { DeviceType } from '../../../shared/types/ast';

type TAdSenseObjectPage = {
    id: string;
    deviceType: DeviceType;
    query: string;
    channel: string;
    width: number;
};
const AdSenseObjectPage = ({
    id = 'afshcontainer',
    deviceType = 'mobile',
    query = '',
    channel = '',
    width = 310,
}: TAdSenseObjectPage) => {
    useAdSenseObjectPage(id, query, channel, 'object', width);

    return (
        <AdSenseForShopping id={id} deviceType={deviceType} className={''} />
    );
};

export default AdSenseObjectPage;
